/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_Status_Pending1Inputs */

const vi_cmspost_status_pending1 = /** @type {(inputs: Cmspost_Status_Pending1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã đăng · có nháp chờ đăng`)
};

/**

* @param {Cmspost_Status_Pending1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_status_pending1 = /** @type {((inputs?: Cmspost_Status_Pending1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Status_Pending1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_status_pending1(inputs)
});
export { cmspost_status_pending1 as "cmsPost_status_pending" }